/** Префикс Mm обязателен: в проекте уже есть чужой глобальный TaskType ценового модуля */

/** Тип задания в теле создания не передаётся — его задаёт адрес запроса */
export enum MmTaskType {
  /** KVI: поиск товара конкурента, заранее сопоставленного с нашим; включается прайс-чекером */
  KVI = 'KVI',
  /** Аудитор подбирает у конкурента такой же товар или аналог */
  FREE = 'FREE',
  /** Самый дешёвый товар подкатегории или категории, ровно один результат на карточку */
  TPC = 'TPC',
  /** Мониторинг уровня целиком, наши товары не участвуют; 0..N результатов на карточку */
  CONTINUOUS = 'CONTINUOUS',
}

export const MM_TASK_TYPES: MmTaskType[] = [
  MmTaskType.KVI,
  MmTaskType.FREE,
  MmTaskType.TPC,
  MmTaskType.CONTINUOUS,
];

export enum MmTaskStatus {
  ASSIGNED = 'assigned',
  COMPLETED = 'completed',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
}

export const MM_TASK_STATUSES: MmTaskStatus[] = [
  MmTaskStatus.ASSIGNED,
  MmTaskStatus.COMPLETED,
  MmTaskStatus.ACCEPTED,
  MmTaskStatus.REJECTED,
];

export enum MmReviewStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  PRICE_CORRECTED = 'price_corrected',
}

export const MM_REVIEW_STATUSES: MmReviewStatus[] = [
  MmReviewStatus.PENDING,
  MmReviewStatus.ACCEPTED,
  MmReviewStatus.REJECTED,
  MmReviewStatus.PRICE_CORRECTED,
];

/** Перечень не закрыт: в модели поле строковое, незнакомый код показываем как есть */
export enum MmOutcome {
  PRICE_CAPTURED = 'price_captured',
  PRODUCT_NOT_FOUND = 'product_not_found',
  NO_PRICE_TAG = 'no_price_tag',
  OUT_OF_STOCK = 'out_of_stock',
  PRICE_NOT_RECOGNIZED = 'price_not_recognized',
  SKIPPED = 'skipped',
  NOT_DONE = 'not_done',
  ANALOG_COMPARE_FAILED = 'analog_compare_failed',
  /** Значение вычисляет фронт: с бэкенда оно не приходит, но без него колонка исхода была бы пустой */
  UNSPECIFIED = 'unspecified',
}

export const MM_OUTCOMES: MmOutcome[] = [
  MmOutcome.PRICE_CAPTURED,
  MmOutcome.PRODUCT_NOT_FOUND,
  MmOutcome.NO_PRICE_TAG,
  MmOutcome.OUT_OF_STOCK,
  MmOutcome.PRICE_NOT_RECOGNIZED,
  MmOutcome.SKIPPED,
  MmOutcome.NOT_DONE,
  MmOutcome.ANALOG_COMPARE_FAILED,
  MmOutcome.UNSPECIFIED,
];

export type MmResultGroupBy = 'group' | 'category' | 'subcategory' | 'none';

/** Для этих трёх уровней значение 0 означает «все» и снимается realValuesOrEmpty() */
export type MmStoreLevelType = 'format' | 'region' | 'cluster';

/** У категорий и подкатегорий 0 — «Не выбрано», пустой массив — «уровень не участвует» */
export type MmProductLevelType = 'group' | 'category' | 'subcategory';

/** Самый низкий явно выбранный уровень товарного дерева */
export type MmMonitoringLevel = MmProductLevelType;

export enum MmSessionState {
  IDLE = 'idle',
  PENDING = 'pending',
  READY = 'ready',
  NETWORK_NOT_SELECTED = 'network_not_selected',
  FORBIDDEN = 'forbidden',
  SP_SESSION_EXPIRED = 'sp_session_expired',
  UNAVAILABLE = 'unavailable',
  MISCONFIGURED = 'misconfigured',
}

export enum MmMessengerType {
  VIBER = 'VIBER',
  WHATSAPP = 'WHATSAPP',
  TELEGRAM = 'TELEGRAM',
  MAX = 'MAX',
}

/** Порядок в этом списке задаёт и показ, и порядок в теле запроса; второго списка не заводить */
export const MM_MESSENGERS: MmMessengerType[] = [
  MmMessengerType.VIBER,
  MmMessengerType.WHATSAPP,
  MmMessengerType.TELEGRAM,
  MmMessengerType.MAX,
];

/** Viber отсутствует намеренно: публичных никнеймов у него нет, адресация только по телефону */
export const MM_MESSENGERS_WITH_USERNAME: MmMessengerType[] = [
  MmMessengerType.WHATSAPP,
  MmMessengerType.TELEGRAM,
  MmMessengerType.MAX,
];

/** Названия мессенджеров не переводятся и в локали не выносятся — это торговые марки */
export const MM_MESSENGER_TITLES: { [code: string]: string } = {
  VIBER: 'Viber',
  WHATSAPP: 'WhatsApp',
  TELEGRAM: 'Telegram',
  MAX: 'MAX',
};

export enum MmErrorCode {
  NETWORK = 'mm_network',
  TIMEOUT = 'mm_timeout',
  /** Запрос отменён (CancelToken) — не ошибка, не показывать пользователю. */
  CANCELED = 'mm_canceled',
  UNAUTHORIZED = 'mm_unauthorized',
  FORBIDDEN = 'mm_forbidden',
  NOT_FOUND = 'mm_not_found',
  CONFLICT = 'mm_conflict',
  PAYLOAD_TOO_LARGE = 'mm_payload_too_large',
  VALIDATION = 'mm_validation',
  SERVER = 'mm_server',
  AUDITORS_NOT_ASSIGNED = 'auditors_not_assigned',
  MISCONFIGURED = 'mm_misconfigured',
  UNKNOWN = 'mm_unknown',
}
